import OrgDetaljerPage from '../OrgDetaljer/OrgDetaljerPage'
export default function KjopereDetaljerPage() { return <OrgDetaljerPage side="kjopere" /> }
